// export const url = 'http://39.105.182.25:8702/'; //测试地址
export const url = 'http://api.yinai188.com/';//冬江本地ip
// export const url = 'http://9.9.20.18:8702/';//李伟本地ip
//export const url = 'http://47.93.192.128:8702/';//杨洋本地ip
//export const url = 'http://59.110.232.63:8702/';//杨洋本地ip

